<template>
    <div style="min-width: 700px;min-height: 90vh;">

        <q-card style="min-height: 90vh;">
            <div class="row q-pa-md">
                <div class="col-12">
                    <div class="d-flex justify-content-between">
                        <h4 class="mt-0 mb-3" style="font-size: 26px; font-weight: 300;">
                            Inventory Items ({{TotalBatchCount}})
                        </h4>
                        <span class="d-block">
                            <q-btn @click="closeInventory" class="q-ml-auto" flat
                                   icon="close" round size="small"></q-btn>
                        </span>
                    </div>
                </div>

                <div class="col-12" v-if="productArr.length">

                    <q-list>
                        <q-item :key="index" clickable v-for="(product, index) in productArr" v-ripple>
                            <q-item-section>{{product.productName}}</q-item-section>
                            <q-item-section avatar>
                                {{product.batchArr.length}}
                            </q-item-section>
                        </q-item>
                    </q-list>

                    <!--<q-list bordered class="rounded-borders">-->
                    <!--<template v-for="(product, index) in productArr">-->
                    <!--<q-expansion-item>-->
                    <!--<template slot="header">-->
                    <!--<q-item-section>-->
                    <!--{{product.productName}}-->
                    <!--</q-item-section>-->
                    <!--<q-item-section side>{{product.batchArr.length}}</q-item-section>-->
                    <!--</template>-->
                    <!--<q-card>-->
                    <!--<q-card-section>-->
                    <!--<q-list class="row" bordered padding>-->
                    <!--<q-item class="col-3" tag="label" v-ripple v-for="(batch, i) in product.batchArr" :key="i">-->


                    <!--<q-item-section>-->
                    <!--<div class="p-3" style="box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.15)">-->
                    <!--<q-item-label>{{batch.batchName}}-->

                    <!--</q-item-label>-->

                    <!--</div>-->
                    <!--</q-item-section>-->
                    <!--</q-item>-->
                    <!--</q-list>-->
                    <!--</q-card-section>-->
                    <!--</q-card>-->
                    <!--</q-expansion-item>-->
                    <!--</template>-->
                    <!--</q-list>-->
                </div>
                <div class="transferType mb-3" v-else>
                    No Items Available .
                </div>
            </div>


        </q-card>
    </div>
</template>

<script>
  import { GET_MY_BATCHES } from '../graphql/queries/batch'
  import Constant from '../Constants/Constant'

  export default {
    apollo: {
      BatchTable: {
        query: GET_MY_BATCHES,
        fetchPolicy: 'network-only',
        variables () {
          return { orgId: this.orgId }
        },
        result ({ data, loading }) {
          if (!loading) {
            this.TotalBatchCount = data.BatchTable.length
            this.groupByProductId(data.BatchTable)
          }
        },
      },
    },
    name: 'InventoryItems',
    props: ['orgId'],
    data: function () {
      return {
        productArr: [],
        TotalBatchCount: 0,
      }
    },
    methods: {
      closeInventory () {
        this.$emit('closeInventoryItemsDialog', false)
      },
      groupByProductId (batches) {
        var self = this
        this.productArr = []

        batches.forEach(function (curnt) {
          if (!Constant.containsObject({ productId: curnt.productId }, self.productArr)) {
            self.productArr.push({ productId: curnt.productId })
          }
        })
        this.productArr.forEach(function (product) {
          product.batchArr = []
          batches.forEach(function (curnt) {
            if (product.productId == curnt.productId) {
              product.batchArr.push({ batchName: curnt.batch, batchChecked: false, batchSku: curnt.sku })
              if (curnt.Product) {
                product.productName = curnt.Product.name
                product.productLineCode = curnt.Product.productLineCode
              }
            }
          })
        })
      },
    },
  }
</script>

<style scoped>

</style>
